module.exports = __webpack_public_path__ + "img/AW.59e31497.png";